<telxl-panel [hover]="true" [cardClass]="cardClass()" bodyClass="pt-1 pb-1">
    <ng-template #cardBody>
        <div class="d-flex align-items-center">
            <div
                class="left"
                tabindex="0"
                [style.cursor]="canPreview() ? 'pointer' : null"
                (click)="preview()"
                (keypress)="preview()"
            >
                <div
                    class="d-flex justify-content-between align-items-center"
                    [class.weight-heavy]="file().state !== 'uploaded'"
                    [class.font-lg]="file().state !== 'uploaded'"
                >
                    <div>
                        @if (file().state === 'uploaded') {
                            <span [style.width.px]="25" class="me-2">
                                <i
                                    class="fa-light"
                                    [ngClass]="fileType()"
                                    [class.preview]="canPreview()"
                                ></i>
                            </span>
                        }
                        {{ file().file.name }}
                    </div>
                    @if (file().state === 'uploaded') {
                        <div class="font-md weight-normal">{{ size() }}</div>
                    }
                </div>
                @switch (file().state) {
                    @case ('failed') {
                        <div class="font-sm fixed-margin text-danger mb-1">
                            Failed
                        </div>
                    }
                    @case ('duplicate') {
                        <div class="font-sm fixed-margin text-warning mb-1">
                            Duplicate file detected
                        </div>
                    }
                    @case ('toolarge') {
                        <div class="font-sm fixed-margin text-warning mb-1">
                            File too large
                        </div>
                    }
                    @case ('unsupported') {
                        <div class="font-sm fixed-margin text-unsupported mb-1">
                            File unsupported
                        </div>
                    }
                }
            </div>
            <div class="right">
                <telxl-button
                    colour="dark"
                    size="sm"
                    [outline]="true"
                    (buttonClick)="remove()"
                >
                    <div class="ms-0 me-0 mt-1 mb-0">
                        <i class="fa-lg fa-light fa-trash-can"></i>
                    </div>
                </telxl-button>
            </div>
        </div>
    </ng-template>
</telxl-panel>
